window.addEventListener('DOMContentLoaded', () => {
  const anchorElements = document.querySelectorAll('a[href^="#"], a[href^="./#"]');

  function hasModifierKey(event) {
    return event.ctrlKey || event.shiftKey || event.altKey || event.metaKey;
  }

  function scrollIntoView(element, offset = 0) {
    const shouldReduceMotion = window.matchMedia('(prefers-reduced-motion)').matches;
    const behavior = shouldReduceMotion ? 'auto' : 'smooth';

    window.scrollTo({
      top: element.offsetTop + offset,
      behavior,
    });
  }

  function handleAnchorClick(event) {
    event.preventDefault();

    const anchorHash = event.currentTarget.hash;

    if (event.button === 0 && !hasModifierKey(event)) {
      if (location.hash !== anchorHash) {
        history.pushState(null, '', anchorHash);
      }

      let scrollTarget =
        anchorHash === '#top' || anchorHash === './#top' || anchorHash === ''
          ? document.documentElement
          : document.querySelector(anchorHash);

      if (scrollTarget) {
        const headerElement = document.querySelector('.js-header');
        let scrollOffset = headerElement ? -headerElement.offsetHeight : 0;
        scrollIntoView(scrollTarget, scrollOffset);
      }
    }
  }

  anchorElements.forEach((anchorElement) => {
    anchorElement.addEventListener('click', handleAnchorClick);
  });
});
